import { render, staticRenderFns } from "./DesktopNavbar.vue?vue&type=template&id=6d055b22&scoped=true"
import script from "./DesktopNavbar.vue?vue&type=script&lang=js"
export * from "./DesktopNavbar.vue?vue&type=script&lang=js"
import style0 from "./DesktopNavbar.vue?vue&type=style&index=0&id=6d055b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d055b22",
  null
  
)

export default component.exports